import type { ReactNode } from 'react';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';

import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';
import './datePickers.css';

const DEFAULT_CALENDAR_ICON = (
  <svg className="w-5 h-5 text-[#888] hover:text-[#444]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
  </svg>
);

interface DateRangeInputProps {
  value: [Date, Date] | null;
  onChange: (range: [Date, Date] | null) => void;
  /** Defaults to the calendar icon used across the app; pass `null` for no icon. */
  calendarIcon?: ReactNode;
}

/**
 * Shared date-range picker — wraps `@wojtekmaj/react-daterange-picker` with
 * the app's CSS (bundled here so callers never need their own CSS imports
 * for it) and default calendar icon. No clear button anywhere in the app
 * needs it, so `clearIcon` isn't exposed as a prop.
 */
export const DateRangeInput = ({ value, onChange, calendarIcon = DEFAULT_CALENDAR_ICON }: DateRangeInputProps) => (
  <div className="modern-date-picker">
    <DateRangePicker
      onChange={(range) => {
        const [start, end] = (range as [Date | null, Date | null] | null) || [null, null];
        onChange(start && end ? [start, end] : null);
      }}
      value={value}
      clearIcon={null}
      calendarIcon={calendarIcon}
    />
  </div>
);
